export default "__VITE_ASSET__C$D81j97__"